import React, { useContext } from "react"
import { useStateMachine } from "#/components/context/stateMachine/StateMachineV2"
import { useCurrentUser } from "#/components/context/user/UserContext"
import { useUserRole } from "#/components/partner-access/hooks/usePartnerAccess"
import { DialogActions, DialogContent, DialogTitle, ForwardIcon } from "@carrotfertility/carotene-core"
import { DialogCloseButton, Form, FormButton, FormRadioGroup } from "@carrotfertility/carotene-core-x"
import { FormattedMessage, useIntl } from "react-intl"
import { OriginDialogContext } from "#/components/telemedicine/pelvic-floor-therapy/OriginDialogContext"
import { FieldValues } from "react-hook-form"

export function WhoWillBeReceivingCareStep(): JSX.Element {
  const { setOpenDialogFlow } = useContext(OriginDialogContext)
  const { isPartnerAccessingAccount } = useUserRole()
  const { preferredName, firstName, partnerPreferredName, partnerFirstName } = useCurrentUser()
  const intl = useIntl()
  const { send } = useStateMachine()

  const partnerName = partnerPreferredName ?? partnerFirstName
  const options = [
    { label: preferredName ?? firstName, value: "MEMBER" },
    {
      label: partnerName ?? intl.formatMessage({ defaultMessage: "{firstName}'s partner" }, { firstName }),
      value: "PARTNER"
    }
  ]

  const onFormSubmit = (formValues: FieldValues) => {
    send(formValues.whoWillBeReceivingCare)
  }

  return (
    <Form onSubmit={onFormSubmit}>
      <DialogCloseButton onClick={() => setOpenDialogFlow(false)} />
      <DialogTitle id="who-will-be-receiving-care-title">
        <FormattedMessage defaultMessage="Who will be receiving the care?" />
      </DialogTitle>
      <DialogContent>
        <FormRadioGroup
          aria-labelledby="who-will-be-receiving-care-title"
          name="whoWillBeReceivingCare"
          options={isPartnerAccessingAccount ? options.reverse() : options}
          controllerProps={{
            rules: {
              required: intl.formatMessage({ defaultMessage: "Required" })
            }
          }}
        />
      </DialogContent>
      <DialogActions>
        <FormButton type="submit" color="secondary" variant="outlined" endIcon={<ForwardIcon />}>
          <FormattedMessage defaultMessage="Continue" />
        </FormButton>
      </DialogActions>
    </Form>
  )
}
